import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useSignIn } from "@clerk/clerk-react";
import OtpVerification, {
  INVALID_CODE_MESSAGE,
} from "../../components/otpVerification";
import { routeEndpoints } from "../../routes/routeEndpoints";

export default function VerifyResetCodePage() {
  const navigate = useNavigate();
  const { isLoaded, signIn } = useSignIn();
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    if (!isLoaded || hasCompletedRef.current || signIn.status !== null) return;

    navigate(routeEndpoints.forgotPassword, { replace: true });
  }, [isLoaded, signIn, navigate]);

  const handleVerify = async (code: string) => {
    if (!isLoaded) return INVALID_CODE_MESSAGE;

    const attempt = await signIn.attemptFirstFactor({
      strategy: "reset_password_email_code",
      code,
    });

    if (attempt.status !== "needs_new_password") return INVALID_CODE_MESSAGE;

    hasCompletedRef.current = true;
    navigate(routeEndpoints.resetPassword, { replace: true });
  };

  const handleResend = async () => {
    if (!isLoaded) return;

    const emailFactor = signIn.supportedFirstFactors?.find(
      (factor) => factor.strategy === "reset_password_email_code",
    );
    if (!emailFactor) throw new Error("Reset factor unavailable");

    await signIn.prepareFirstFactor({
      strategy: "reset_password_email_code",
      emailAddressId: emailFactor.emailAddressId,
    });
  };

  return (
    <OtpVerification
      backLabel="Back to Login"
      backTo={routeEndpoints.login}
      isLoaded={isLoaded}
      onVerify={handleVerify}
      onResend={handleResend}
    />
  );
}
